import MapInfo from '../components/MapInfo';
import StateCta from '../components/StateCta';
import ButtonCta from '../components/ButtonCta';
import LandingPageCta from '../components/LandingPageCta';
import SideBySide from '../components/content/SideBySide';
import ResponsiveImg from '../components/ResponsiveImg';
import VideoIframe from '../components/VideoIframe';
import HrefLangManager from '../components/HrefLangManager';
import TableOfContents from '../components/TableOfContents';
import Table from '../components/content/Table';
import ImagePrefixer from '../components/content/ImagePrefixer';
import QuestionAccordion from '../components/QuestionAccordion';
import TwoColCta from '../components/TwoColCta';
import ThreeColCta from '../components/ThreeColCta';
import TrustLogos from '../components/TrustLogos';
import LinkWithQuery from '../components/LinkWithQuery';
import DynamicPreviousDate from '../components/DynamicPreviousDate';
import DoubleVideo from '../components/DoubleVideo';
import IconWithText from '../components/IconWithText';

export const fpqUrl = 'https://www.hear.com/d/full_page_questionnaire/';
export const shortCodes = {
	StateCta,
	MapInfo,
	ButtonCta,
	LandingPageCta,
	LinkWithQuery,
	SideBySide,
	ResponsiveImg,
	VideoIframe,
	HrefLangManager,
	TableOfContents,
	Table,
	ImagePrefixer,
	QuestionAccordion,
	TwoColCta,
	ThreeColCta,
	TrustLogos,
	DynamicPreviousDate,
	DoubleVideo,
	IconWithText
};
